export default "__VITE_ASSET__DexVOgdJ__"